export const designCenterConst ={
  VIEW_ALL_ASSETS_REQUEST: 'VIEW_ALL_ASSETS_REQUEST',
  VIEW_ALL_ASSETS_SUCCESS: 'VIEW_ALL_ASSETS_SUCCESS',
  VIEW_ALL_ASSETS_FAILURE: 'VIEW_ALL_ASSETS_FAILURE',

  ADD_ASSET: 'ADD_ASSET_REQUEST',
  ADD_ASSET_SUCCESS: 'ADD_ASSET_SUCCESS',
  ADD_ASSET_FAILURE: 'ADD_ASSET_FAILURE',

  UPDATE_ASSET: 'UPDATE_ASSET_REQUEST',
  UPDATE_ASSET_SUCCESS: 'UPDATE_ASSET_SUCCESS',
  UPDATE_ASSET_FAILURE: 'UPDATE_ASSET_FAILURE',

  DELETE_ASSET: 'DELETE_ASSET_REQUEST',
  DELETE_ASSET_SUCCESS: 'DELETE_ASSET_SUCCESS',
  DELETE_ASSET_FAILURE: 'DELETE_ASSET_FAILURE',

  VIEW_ASSET_DETAIL: 'VIEW_ASSET_DETAIL_REQUEST',
  VIEW_ASSET_DETAIL_SUCCESS: 'VIEW_ASSET_DETAIL_SUCCESS',
  VIEW_ASSET_DETAIL_FAILURE: 'VIEW_ASSET_DETAIL_FAILURE',

  VIEW_ALL_ASSETS_COLOR_REQUEST: 'VIEW_ALL_ASSETS_COLOR_REQUEST',
  VIEW_ALL_ASSETS_COLOR_SUCCESS: 'VIEW_ALL_ASSETS_COLOR_SUCCESS',
  VIEW_ALL_ASSETS_COLOR_FAILURE: 'VIEW_ALL_ASSETS_FAILURE',

  ADD_ASSET_COLOR: 'ADD_ASSET_COLOR_REQUEST',
  ADD_ASSET_COLOR_SUCCESS: 'ADD_ASSET_COLOR_SUCCESS',
  ADD_ASSET_COLOR_FAILURE: 'ADD_ASSET_COLOR_FAILURE',

  UPDATE_ASSET_COLOR: 'UPDATE_ASSET_COLOR_REQUEST',
  UPDATE_ASSET_COLOR_SUCCESS: 'UPDATE_ASSET_COLOR_SUCCESS',
  UPDATE_ASSET_COLOR_FAILURE: 'UPDATE_ASSET_COLOR_FAILURE',

  VIEW_ASSET_COLOR_DETAIL: 'VIEW_ASSET_COLOR_DETAIL_REQUEST',
  VIEW_ASSET_COLOR_DETAIL_SUCCESS: 'VIEW_ASSET_COLOR_DETAIL_SUCCESS',
  VIEW_ASSET_COLOR_DETAIL_FAILURE: 'VIEW_ASSET_COLOR_DETAIL_FAILURE',

  VIEW_THEME_DATA: 'VIEW_THEME_DATA_REQUEST',
  VIEW_THEME_DATA_SUCCESS: 'VIEW_THEME_DATA_SUCCESS',
  VIEW_THEME_DATA_FAILURE: 'VIEW_THEME_DATA_FAILURE',

  VIEW_ALL_CUSTOMPAGE_REQUEST: 'VIEW_ALL_CUSTOMPAGE_REQUEST',
  VIEW_ALL_CUSTOMPAGE_SUCCESS: 'VIEW_ALL_CUSTOMPAGE_SUCCESS',
  VIEW_ALL_CUSTOMPAGE_FAILURE: 'VIEW_ALL_CUSTOMPAGE_FAILURE',

  CUSTOMPAGE_ADD_REQUEST: 'CUSTOMPAGE_ADD_REQUEST',
  CUSTOMPAGE_ADD_SUCCESS: 'CUSTOMPAGE_ADD_SUCCESS',
  CUSTOMPAGE_ADD_FAILURE: 'CUSTOMPAGE_ADD_FAILURE',

  CUSTOMPAGE_UPDATE_REQUEST: 'CUSTOMPAGE_UPDATE_REQUEST',
  CUSTOMPAGE_UPDATE_SUCCESS: 'CUSTOMPAGE_UPDATE_SUCCESS',
  CUSTOMPAGE_UPDATE_FAILURE: 'CUSTOMPAGE_UPDATE_FAILURE',

  CUSTOMPAGE_DELETE_REQUEST: 'CUSTOMPAGE_DELETE_REQUEST',
  CUSTOMPAGE_DELETE_SUCCESS: 'CUSTOMPAGE_DELETE_SUCCESS',
  CUSTOMPAGE_DELETE_FAILURE: 'CUSTOMPAGE_DELETE_FAILURE',
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/designCenterConst.js